// trackingService.js
import { useEffect, useState } from 'react';
import { useLocation } from '@reach/router';
import UAParser from "ua-parser-js";
import axios from "axios";

function getLocalStorage() {
    if (typeof window === 'undefined') return null;
    try {
        return window.localStorage;
    } catch {
        return null;
    }
}

function getSessionStorage() {
    if (typeof window === 'undefined') return null;
    try {
        return window.sessionStorage;
    } catch {
        return null;
    }
}
export function useUserTracking() {
    const pathToPageName = {
        "/": "Home Page",
        "/work/": "Work Page",
        "/contact/": "Contact Page",
        "/casestudies/web-apps/": "Casestudies > Web Apps Page",
        "/casestudies/websites/": "Casestudies > Websites Page",
        "/casestudies/mobile-apps/": "Casestudies > Mobile Apps Page",
        "/casestudies/e-commerce/": "Casestudies > Ecommerce Page", 
    };
    const location = useLocation();
    const [ipCountry, setIpCountry] = useState("");
    const fetchIpCountry = async () => {
        try {
            const response = await axios.get("https://ipapi.co/json");
            const { country_name, city, region } = response.data;
            let location = `${country_name}, ${region}, ${city}`;
            setIpCountry(location);
        } catch (error) {
            console.error("Error retrieving IP country:", error);
        }
    };
    
    const getLastEntryKey = (a, searchValue) => {
        const matchingIndexes = a.reduce((indexes, obj, index) => {
            // if (obj.page === searchValue) {
            indexes.push(index);
            //   }
            return indexes;
        }, []);
        return matchingIndexes[matchingIndexes.length - 1]
    }
   

    function clearTrackingDataFromLocalStorage() {
        getLocalStorage()?.removeItem('trackingData');
    }
    function createPageNameFromSlug(slug) {
        // Check if the slug is just a single slash
        if (slug === '/') {
          return 'Home Page';
        }
      
        // Remove leading and trailing slashes
        slug = slug.replace(/^\/|\/$/g, '');
      
        // Split the slug into parts
        const parts = slug.split('/');
      
        // Capitalize each part and join them with ' > '
        const pageName = parts
          .map(part => part.charAt(0).toUpperCase() + part.slice(1).replace(/-/g, ' '))
          .join(' > ');
      
        // Add 'Page' at the end
        return `${pageName} Page`;
      }
    async function trackPageView(page) {
        const uaParser = new UAParser();
        const userAgent = uaParser.getResult();
        //console.log({ width: window.innerWidth, height: window.innerHeight })
        const timestamp = new Date().toISOString();
        const trackingData = getTrackingDataFromLocalStorage();
        let pageName=createPageNameFromSlug(page);//pathToPageName[page]?pathToPageName[page]:
        trackingData.push({pageName, page, timestamp, totalTimeSpendInSec: 0 });
        saveTrackingDataToLocalStorage(trackingData);
    }
    

    useEffect(() => {
        
        unlisten(() => {
            //console.log(location)
            trackPageView(location.pathname);
            clearInterval(intervalID)
            time = 0
        });
        var time = 0;
        var intervalID = setInterval(() => {
            time += 1
            getSessionStorage()?.setItem("time", String(time));
            
        }, 1000)

        return () => {
            // Cleanup the event listener when the component unmounts
        };
    }, [location]);

    return { clearTrackingDataFromLocalStorage }
}

export const unlisten = (cb) => {
    const timestamp = new Date().toISOString();
    const timeformated = new Date().toISOString();
    const trackingData = getTrackingDataFromLocalStorage();
    let isDataExist = getLastEntryKey(trackingData)
    if (isDataExist >= 0) {
        const session = getSessionStorage();
        const timesession = parseInt(session?.getItem("time") ?? "0", 10) || 0;
        let totalTime = trackingData[isDataExist].totalTimeSpendInSec + timesession
        if(totalTime != null){

            trackingData[isDataExist].lastvistTimestamp = timestamp;
            trackingData[isDataExist].totalTimeSpendInSec = totalTime;
            trackingData[isDataExist].timeformated = formatedTime();
            trackingData[isDataExist].totalTimeSpendInMin = fancyTimeFormat(totalTime);
            saveTrackingDataToLocalStorage(trackingData); 
            session?.setItem("time", "0");
        }
    }
    cb()
};
export function getTrackingDataFromLocalStorage() {
    const storage = getLocalStorage();
    if (!storage) return [];
    const trackingData = storage.getItem('trackingData');
    if (!trackingData) return [];
    try {
        return JSON.parse(trackingData);
    } catch {
        return [];
    }
}
export const getLastEntryKey = (a) => {
    const matchingIndexes = a.reduce((indexes, obj, index) => {
        // if (obj.page === searchValue) {
        indexes.push(index);
        //   }
        return indexes;
    }, []);
    return matchingIndexes[matchingIndexes.length - 1]
}
export function formatedTime() {
    const now = new Date();

    const options = {
        timeZone: 'Australia/Melbourne',
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    };

    const formatter = new Intl.DateTimeFormat('en-AU', options);
    const melbourneDateTime = formatter.format(now);

    // Adding custom text 'at'
    return melbourneDateTime.replace(',', ' at');
}
export  function saveTrackingDataToLocalStorage(data) {
    getLocalStorage()?.setItem('trackingData', JSON.stringify(data));
}

export function fancyTimeFormat(duration) {
    // Hours, minutes and seconds
    const hrs = ~~(duration / 3600);
    const mins = ~~((duration % 3600) / 60);
    const secs = ~~duration % 60;
    // Output like "1:01" or "4:03:59" or "123:03:59"
    let ret = "";

    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;

    return ret;
}